import React from 'react'
import Navbar from '../../components/common/navbar';
import { Paper } from '@mui/material';
import PublicationCard from '../../components/publication/card';


function Publication() {
  return (
    <>
      <Navbar />
      <Paper>
        <div className='p-5'>
          <h1 className='text-center'> Publication</h1>
            <Paper elevation={3}>
          <div>
            <PublicationCard />
          </div>
            </Paper>
        </div>
      </Paper>
    </>
  )
}

export default Publication